import { type ServerResponse, axios } from '~/axios'
import { type Role } from '~/utils/types/user'

export async function getAllPSTeamUsers() {
  const query = /* GraphQL */ `
    query {
      listAllPsTeamUsers {
        id
        username
        role
      }
    }
  `

  return await axios.post<
    ServerResponse<{
      listAllPsTeamUsers: Array<{ id: number; username: string; role: Role }>
    }>
  >('/graphql', { query })
}

export async function getAllHubUsersByHubIds(hubs: number[]) {
  const query = /* GraphQL */ `
    query listAllHubUsersByHub($hubs: [Long]) {
      listAllHubUsersByHub(hubs: $hubs) {
        id
        username
        role
      }
    }
  `

  return await axios.post<
    ServerResponse<{
      listAllHubUsersByHub: Array<{ id: number; username: string; role: Role }>
    }>
  >('/graphql', {
    query,
    variables: { hubs },
  })
}
